"use client";

import { cn } from "@/lib/utils";

interface CopyrightYearProps {
  className?: string;
}

export function CopyrightYear({ className }: CopyrightYearProps) {
  return (
    <span className={cn("text-sm select-none", className)}>
      © {new Date().getFullYear()} All Rights Reserved by Terac
    </span>
  );
}
